import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, FormGroup, Form } from 'reactstrap';
import WOPieChart from "./_ModalsForms/KPI Board/WOPieChart";
import WOColumnBarChart from "./_ModalsForms/KPI Board/WOColumnBarChart";
import WOUserProgress from "./_ModalsForms/KPI Board/WOUserProgress";
import PMUpcomingWork from "./_ModalsForms/KPI Board/PMUpcomingWork";


class WorkOrderKPIBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                <div className="border_container">
                    <div className="main_container content">
                        <Form>
                            <FormGroup row className="First_Row_Boxes">
                                <Col sm={{ size: 6 }} className="tab_split">
                                    <WOColumnBarChart WorkOrderList={this.props.WorkOrderList} PMList={this.props.PMList} redirect_WO_PM_Details={this.props.redirect_WO_PM_Details}/>
                                </Col>
                                <Col sm={{ size: 6 }} className="tab_split">
                                    <WOPieChart WorkOrderList={this.props.WorkOrderList} WorkOrderClosedList={this.props.WorkOrderClosedList}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row className="Second_Row_Boxes">
                                <Col sm={{ size: 6 }} className="tab_split">
                                    <WOUserProgress WorkOrderList={this.props.WorkOrderList} WorkOrderClosedList={this.props.WorkOrderClosedList} />
                                </Col>
                                <Col sm={{ size: 6 }} className="tab_split">
                                    <PMUpcomingWork PMList={this.props.PMList} PMClosedList={this.props.PMClosedList}  redirect_WO_PM_Details={this.props.redirect_WO_PM_Details}/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
       
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderKPIBoard);
